import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";

const BlogCard = ({ blog }) => {
  return (
    <div className="blog-card h-100">
      <div className="blog-img-wrapper">
        <img src={blog.image} alt={blog.title} />
      </div>

      <div className="blog-content">
        <h5>{blog.title}</h5>
        <p>{blog.description}</p>

        <Link to={`/blogs/${blog.slug}`} className="read-more">
          <span className="read-text">Read More</span>
          <span className="arrow-circle">
            <i className="fas fa-arrow-up"></i>
          </span>
        </Link>

      </div>
    </div>
  );
};

export default BlogCard;
